/** Microsoft 365 for the person: Bağlantılar, the connect dialog, Ayarlar › Hesap › Bağlı hesaplar, chat notices (Phase 15e). */
export const m365UserTr = {
  name: 'Microsoft 365',
  // the product lineup; Microsoft's Outlook icon goes only before these full names
  products: {
    label: 'Ürünler',
    mail: 'Outlook mail',
    calendar: 'Outlook takvim',
    // part 3, while the firm has them on
    onedrive: 'OneDrive',
    sharepoint: 'SharePoint',
    ready: 'bağlı',
    off: 'kapalı',
  },
  // Bağlantılar (MsBaglantilar)
  connectors: {
    chip: 'Hazır',
    section: 'Hazır bağlantılar',
    sectionHint: 'Oppy ile gelir; şirketiniz açtıysa tek tıkla bağlanırsınız',
    empty: 'Şirketiniz henüz hazır bağlantı açmadı.',
  },
  card: {
    description: 'Mailleriniz ve takviminiz hakkında soru sorun.',
    // part 3 (MsBaglantilar), by the switches the firm has on
    descriptionWrite: 'Mailleriniz ve takviminiz hakkında soru sorun, yanıt yazdırın.',
    descriptionDocs: "Mailleriniz ve takviminiz hakkında soru sorun; OneDrive ve SharePoint'ten belge getirin.",
    descriptionAll: "Mailleriniz ve takviminiz hakkında soru sorun, yanıt yazdırın; OneDrive ve SharePoint'ten belge getirin.",
    state: {
      connected: 'Bağlı',
      not_connected: 'Hesabınızı bağlayın',
      needs_reconnect: 'Yeniden bağlanın',
      consent_required: 'Yönetici onayı bekleniyor',
      unavailable: 'Kullanılamıyor',
      off_firm: 'Şirketiniz kapattı',
      not_allowed: 'Ekibinize açık değil',
      off_team: 'Ekibiniz için kapalı',
      not_configured: 'Kurulmadı',
    },
    connect: 'Hesabımı bağla',
    reconnect: 'Yeniden bağlan',
    retry: 'Yeniden dene',
    toggle: "Microsoft 365'i aç ya da kapat",
    menu: 'Microsoft 365 için işlemler',
    details: 'Ayrıntılar',
    remove: 'Bağlantıyı kaldır',
    removeTitle: 'Microsoft bağlantınız kaldırılsın mı?',
    removeBody:
      "Oppy'deki anahtarınız silinir; Oppy mailinize ve takviminize artık bakamaz. Oppy'nin daha önce okudukları sohbetlerinizde kalır. Microsoft hesabınız ve mailleriniz olduğu gibi kalır. İstediğiniz zaman yeniden bağlanabilirsiniz.",
    body: {
      reconnect: "Microsoft hesabınız artık Oppy'ye izin vermiyor. Yeniden bağlanınca devam eder.",
      consent: 'Microsoft, bu izinler için şirketinizin yöneticisinin onayını istiyor. Bilgi işlem ekibinize haber verin.',
      unavailable: "Sunucu şu an Microsoft'a bağlanamıyor. Biraz sonra yeniden deneyin; sürerse yöneticinize haber verin.",
      unavailableAdmin: "Sunucu şu an Microsoft'a bağlanamıyor. <go>Yönetim › Entegrasyonlar</go>'da bağlantıyı test edin.",
      switchedOff: 'Kapattınız: Oppy mailinize ve takviminize bakmaz. Hesabınız bağlı kalır.',
    },
    off: {
      offFirm: "Şirketiniz Microsoft 365'i kapattı. Açılınca buradan bağlanabilirsiniz.",
      notAllowed: "Şirketiniz Microsoft 365'i yalnız seçili ekiplere açtı; ekibiniz bunlardan biri değil.",
      offTeam: "Ekip yöneticiniz Microsoft 365'i ekibiniz için kapattı.",
      offTeamNamed: "{{team}} ekibinin yöneticisi Microsoft 365'i ekip için kapattı.",
      notConfigured: 'Microsoft 365 şirketinizde kurulu değil.',
    },
    setup: "<go>Yönetim › Entegrasyonlar</go>'dan kurun",
    setupNote: 'Kurulana kadar bu kartı yalnız yöneticiler görür.',
    foot: {
      open: 'Şirketiniz açtı · her kişi kendi Microsoft hesabıyla bağlanır · Oppy parolanızı görmez',
      connected: '{{email}} olarak bağlı · Oppy yalnız okur, hiçbir şey göndermez',
      account: '{{email}} · Oppy yalnız okur, hiçbir şey göndermez',
      readOnly: 'Oppy yalnız okur, hiçbir şey göndermez',
      // part 3: sending or meetings is on
      connectedWrite: '{{email}} olarak bağlı · Oppy onayınız olmadan hiçbir şey göndermez',
      accountWrite: '{{email}} · Oppy onayınız olmadan hiçbir şey göndermez',
      readOnlyWrite: 'Oppy onayınız olmadan hiçbir şey göndermez',
    },
    everywhere: 'Microsoft 365 anahtarı her yerde geçerlidir; çalışma alanına göre değişmez.',
  },
  // "Ayrıntılar": the read tools in plain words
  tools: {
    note: 'Hepsi yalnız okur; Oppy bunları sormadan kullanır ve hiçbir şey göndermez.',
    readOnly: 'Salt okunur',
    off: 'Şirketiniz kapattı',
    mail_ara: { title: 'Mail ara', text: 'Gelen kutunuzda ve gönderdiklerinizde mail arar.' },
    mail_oku: { title: 'Mail oku', text: 'Bir mailin metnini okur.' },
    eki_oku: { title: 'Eki oku', text: 'Siz isteyince bir mailin ekini okur (PDF, Word, Excel, PowerPoint).' },
    takvime_bak: { title: 'Takvime bak', text: 'Bir günün ya da birkaç günün toplantılarını listeler.' },
    toplanti_ayrintisi: { title: 'Toplantı ayrıntısı', text: 'Bir toplantının katılımcılarını ve notunu okur.' },
    uygun_saat_bul: { title: 'Uygun saat bul', text: 'Kişilerin takviminde yalnız dolu/boş bilgisine bakar.' },
    // part 3: each one opens a card; nothing goes out before the person presses it
    writeNote: 'Her biri bir onay kartı açar; siz Gönder ya da Oluştur demeden hiçbir şey gitmez.',
    approval: 'Her seferinde onayınızla',
    grant: 'İzin gerekiyor',
    yanit_taslagi: { title: 'Yanıt taslağı', text: 'İstediğiniz bir maile yanıt hazırlar ve kartta gösterir.' },
    taslagi_gonder: { title: 'Taslağı gönder', text: "Outlook'taki bir taslağı kartta gösterir ve onayınızla gönderir." },
    mail_gonder: { title: 'Yeni mail gönder', text: 'Yazdığınız ya da adını verdiğiniz kişilere yeni bir mail hazırlar.' },
    toplanti_olustur: { title: 'Toplantı oluştur', text: 'Toplantıyı kartta gösterir; onayınızla oluşturur ve davetleri gönderir.' },
  },
  consent: {
    request: 'Yöneticiye bildir',
    sent: 'Yöneticinize haber verildi.',
    already: 'Yöneticinize kısa süre önce haber verildi.',
  },
  // "Hesabımı bağla" (MsBaglanOnay)
  dialog: {
    title: 'Microsoft hesabınızı bağlayın',
    subtitle: 'Şirket hesabınızla girin (ör. ad.soyad@sirketiniz.com)',
    can: 'Oppy şunları yapabilecek',
    canItems: {
      find: 'Maillerinizi bulmak, okumak, özetlemek',
      calendar: 'Takviminizdeki toplantıları okumak',
      attachments: 'Siz isteyince mail eklerini okumak',
      schedule: 'Toplantı için uygun saat bulmak (yalnız dolu/boş)',
      // part 3 (MsBaglanOnay), when the firm has them on
      documents: "OneDrive ve SharePoint'ten seçtiğiniz belgeleri getirmek",
      onedrive: "OneDrive'dan seçtiğiniz belgeleri getirmek",
      sharepoint: "SharePoint'ten seçtiğiniz belgeleri getirmek",
      sendAndMeet: 'Onayınızla mail göndermek ve toplantı oluşturmak',
      send: 'Onayınızla mail göndermek',
      meetings: 'Onayınızla toplantı oluşturmak',
    },
    cannot: 'Oppy şunları yapmaz',
    cannotItems: {
      send: 'Mail göndermez, toplantı kurmaz',
      sendApproval: 'Onayınız olmadan mail göndermez, toplantı kurmaz',
      sendApprovalMail: 'Onayınız olmadan mail göndermez; toplantı kurmaz',
      sendApprovalMeeting: 'Mail göndermez; onayınız olmadan toplantı kurmaz',
      delete: 'Hiçbir maili ya da dosyayı silmez',
      password: 'Parolanızı görmez, saklamaz',
      others: 'Başkasının mailine bakmaz',
    },
    // "Yeniden bağlan" for a new permission (no mockup): only the new promises
    upgrade: {
      title: 'Microsoft hesabınıza yeni izin verin',
      subtitle: 'Microsoft size yalnız yeni izni soracak; okuma izinleriniz değişmez.',
      can: 'Oppy bundan sonra şunları da yapabilecek',
    },
    noteRedirect:
      "Microsoft'un giriş sayfası açılacak. Girişten sonra buraya kendiliğinden dönersiniz. Bağlantıyı istediğiniz zaman <b>Ayarlar › Hesap › Bağlı hesaplar</b>'dan kaldırabilirsiniz.",
    noteDevice:
      "Microsoft'un sayfasında, burada göreceğiniz kodu girersiniz. Bağlantıyı istediğiniz zaman <b>Ayarlar › Hesap › Bağlı hesaplar</b>'dan kaldırabilirsiniz.",
    continueRedirect: "Microsoft'ta devam et",
    continueDevice: 'Devam et',
    badUrl: "Microsoft'un giriş sayfası açılamadı. Yöneticinize haber verin.",
    // "Kodla" (device code)
    device: {
      intro: "Microsoft'un sayfasında bu kodu girin:",
      steps: {
        open: "\"Microsoft'un sayfasını aç\" ile sayfayı yeni sekmede açın.",
        enter: 'Kodu yapıştırıp şirket hesabınızla girin ve izin verin.',
        done: 'Girişten sonra bu pencere kendiliğinden kapanır.',
      },
      open: "Microsoft'un sayfasını aç",
      waiting: 'Girişiniz bekleniyor…',
      until: 'Kodun son geçerlilik saati: {{time}}',
      expired: 'Kodun süresi doldu. Yeni bir kod alıp yeniden deneyin.',
      declined: "Girişi Microsoft'ta iptal ettiniz. İsterseniz yeniden deneyin.",
      newCode: 'Yeni kod al',
    },
  },
  // back from Microsoft (?microsoft365=connected|error&reason=…; MsBaglandi)
  result: {
    connected: 'Microsoft hesabınız bağlandı. Artık mailleriniz ve takviminiz hakkında soru sorabilirsiniz.',
    failed: 'Microsoft hesabınız bağlanamadı.',
  },
  reasons: {
    state_invalid: 'Girişin süresi doldu ya da başka bir pencerede başlatıldı. Yeniden deneyin.',
    access_denied: "Microsoft'taki girişi iptal ettiniz ya da izin vermediniz. İsterseniz yeniden deneyin.",
    consent_required: 'Microsoft, bu izinler için şirketinizin yöneticisinin onayını istiyor. Bilgi işlem ekibinize haber verin.',
    personal_account: 'Kişisel Microsoft hesabıyla (outlook.com, hotmail.com) bağlanılamaz. Şirket hesabınızla girin.',
    other_tenant: 'Bu hesap şirketinizin Microsoft hesaplarından biri değil. Şirket hesabınızla girin.',
    guest_account: 'Misafir hesapla bağlanılamaz. Şirketteki kendi hesabınızla girin.',
    wrong_account: "Bu Microsoft hesabı sizin Oppy hesabınızla eşleşmiyor. Oppy'ye girdiğiniz e-posta adresiyle aynı Microsoft hesabıyla girin.",
    id_token_invalid: "Microsoft'un yanıtı doğrulanamadı. Yeniden deneyin; sürerse yöneticinize haber verin.",
    exchange_failed: 'Microsoft girişi tamamlanamadı. Yeniden deneyin; sürerse yöneticinize haber verin.',
    not_available: "Microsoft 365'i şu an kullanamazsınız; şirketiniz ya da ekibiniz kapattı.",
    unavailable: "Sunucu şu an Microsoft'a ulaşamıyor. Biraz sonra yeniden deneyin.",
    unknown: 'Bir sorun oldu. Yeniden deneyin; sürerse yöneticinize haber verin.',
  },
  // Ayarlar › Hesap › Bağlı hesaplar (MsBagliHesaplar)
  linked: {
    title: 'Bağlı hesaplar',
    account: '{{email}} · bağlandı: {{connected}}',
    lastUsed: 'son kullanım: {{used}}',
    notConnected: 'Bağlı değil. Bağlarsanız Oppy mailinizi ve takviminizi okuyabilir.',
    read: 'Okuma açık',
    off: 'Kapalı',
    // part 3's rows (MsBagliHesaplar); "İzin gerekiyor" has no mockup
    rows: { mail: 'Outlook mail', calendar: 'Outlook takvim', mailSend: 'Mail gönderme', calendarWrite: 'Toplantı oluşturma', onedrive: 'OneDrive', sharepoint: 'SharePoint' },
    values: { read: 'Okuma açık', approval: 'Her seferinde onayınızla', on: 'Açık', grant: 'İzin gerekiyor', off: 'Kapalı' },
    grantAction: 'Yeniden bağlan',
    grantLabel: '{{row}} için yeniden bağlan',
    removeNote: "Kaldırırsanız Oppy'deki anahtarınız silinir. Oppy'nin daha önce okudukları sohbetlerinizde kalır.",
    removeNoteDocs: "Kaldırırsanız Oppy'deki anahtarınız silinir; getirdiğiniz belgeler Belgeler'de kalır.",
    none: 'Başka bağlı hesabınız yok. Diğer bağlantılar <go>Bağlantılar</go> sayfasında.',
    others: 'Diğer bağlantılar <go>Bağlantılar</go> sayfasında.',
  },
  // the chat's cards after a turn stopped for Microsoft 365 (MsDurumlar)
  notice: {
    connected: { title: 'Microsoft hesabınız bağlı', text: 'Oppy az önce yanıtlayamadığı soruyu şimdi yanıtlayabilir.' },
    notConnected: { title: 'Bunun için Microsoft hesabınızı bağlayın', text: 'Bağladıktan sonra Oppy sorunuzu kendiliğinden yanıtlar.' },
    reconnect: { title: 'Microsoft bağlantınızı yenilemeniz gerekiyor', text: "Microsoft hesabınız artık Oppy'ye izin vermiyor. Yeniden bağlanınca devam eder." },
    consent: { title: 'Şirketinizin onayı bekleniyor', text: 'Microsoft, bu izinler için şirketinizin yöneticisinin onayını istiyor. Bilgi işlem ekibinize haber verin.' },
    // part 3 (no mockup): the feature is on, the account has not granted its permission yet; the button is "Yeniden bağlan"
    scopes: { title: 'Yeni izin gerekiyor', text: 'Bu iş için Microsoft hesabınıza bir kez daha bağlanın; Microsoft size yeni izni soracak.' },
    // v0.15e.1: shown only when the server could not reach Microsoft at all; one failed call is the assistant's to explain
    unavailable: { title: 'Microsoft 365 şu an kullanılamıyor', text: "Sunucu şu an Microsoft'a bağlanamıyor. Biraz sonra yeniden deneyin; sürerse yöneticinize haber verin." },
    unavailableAdmin: { title: 'Microsoft 365 şu an kullanılamıyor', text: "Sunucu şu an Microsoft'a bağlanamıyor. Sürerse: <go>Yönetim › Entegrasyonlar</go> › Bağlantıyı test et." },
    notAvailable: { title: 'Microsoft 365 sizin için kapalı', text: 'Şirketiniz ya da ekibiniz kapattı. Açılınca yeniden sorabilirsiniz.' },
    offFirm: { title: 'Microsoft 365 şirketinizde kapalı', text: 'Şirketiniz kapattı. Açılınca yeniden sorabilirsiniz.' },
    notAllowed: { title: 'Microsoft 365 ekibinize açık değil', text: 'Şirketiniz yalnız seçili ekiplere açtı.' },
    offTeam: { title: 'Microsoft 365 ekibiniz için kapalı', text: 'Ekip yöneticiniz kapattı.' },
    offTeamNamed: { title: 'Microsoft 365 ekibiniz için kapalı', text: '{{team}} ekibinin yöneticisi kapattı.' },
    notConfigured: { title: 'Microsoft 365 şirketinizde kurulu değil', text: 'Kurulum için şirket yöneticinize başvurun.' },
    switchedOff: { title: "Microsoft 365'i kapattınız", text: 'Bağlantılar sayfasından yeniden açabilirsiniz.' },
    mailOff: { title: 'Outlook mail okuma kapalı', text: "Şirketiniz Oppy'nin maillerinizi okumasını kapattı." },
    calendarOff: { title: 'Outlook takvim okuma kapalı', text: "Şirketiniz Oppy'nin takviminizi okumasını kapattı." },
    continue: 'Devam et',
    connectors: 'Bağlantılar sayfasını aç',
  },
  // the conversation bar
  chip: { connected: 'Microsoft 365 bağlı', hint: '{{email}} hesabıyla bağlı' },
};

/** API error texts of the built-in connection, merged into `errors` (D-39: plain words, the action first). */
export const m365ErrorsTr = {
  microsoft_not_configured: { title: 'Microsoft 365 firmanızda henüz kurulmadı.', action: 'Kurulum için firma yöneticinize başvurun.' },
  microsoft_not_available: { title: "Microsoft 365'i şu an kullanamazsınız; firmanız ya da ekibiniz kapattı.", action: 'Ekip yöneticinize ya da firma yöneticinize başvurun.' },
  microsoft_not_connected: { title: 'Microsoft hesabınız bağlı değil.', action: 'Bağlantılar sayfasındaki Microsoft 365 kartından hesabınızı bağlayın.' },
  microsoft_reconnect: { title: 'Microsoft bağlantınızı yenilemeniz gerekiyor.', action: 'Bağlantılar sayfasında "Yeniden bağlan" düğmesini kullanın.' },
  microsoft_consent_required: { title: 'Microsoft, bu izinler için şirketinizin yöneticisinin onayını istiyor.', action: 'Bilgi işlem ekibinize haber verin.' },
  microsoft_unavailable: { title: "Sunucu şu an Microsoft'a ulaşamıyor.", action: 'Biraz sonra yeniden deneyin; sürerse yöneticinize haber verin.' },
  microsoft_secret_required: { title: 'Doğrudan giriş için gizli anahtar gerekiyor.', action: "Microsoft'taki kayıttan yeni bir istemci gizli dizisi oluşturup buraya yapıştırın." },
  // part 3
  microsoft_scopes_required: { title: 'Yeni izin gerekiyor.', action: 'Microsoft hesabınıza bir kez daha bağlanın; Microsoft size yeni izni soracak.' },
  microsoft_card_required: { title: 'Bu onay kartı burada gönderilemez.', action: "Kartı sohbette web'den gönderin ya da vazgeçin." },
  microsoft_card_changed: { title: 'Bu kart artık gösterildiği gibi değil.', action: 'Sohbeti yenileyip kartın son haline bakın.' },
  recipient_not_allowed: { title: 'Deneme kipinde yalnız izin verilen adreslere gönderilebilir.', action: 'Alıcıyı değiştirin ya da yöneticinize başvurun.' },
  acknowledgement_required: { title: 'Paylaşmadan önce uyarıyı onaylamanız gerekiyor.', action: '"Anladım" kutusunu işaretleyip yeniden deneyin.' },
};
